module.exports = __webpack_public_path__ + "img/instagram.647ba738.png";